import { DoArraysOverlap, FormatStringByWordLength, Split, Join } from "../../../shared/scripts/array-functions";
import { GetDateFromString } from "../../../shared/scripts/date-functions";


export class Task {
    SortOrder: number;
    Name: string;
    TaskCategory: string;
    CompletionCriteria: string;
    PlannedStartDate: string = "";
    PlannedEndDate: string = "";
    ActualStartDate: string = "";
    ActualEndDate: string = "";
    Comments: string;
    StatusId: number;
    Status: string;
    IsMilestoneTask: string;
    IsCriticalTask: string;
    IsMostCurrentTask: string;
    IsKeyDocument: string;
    StudyArea: string;
    StaffPipeSeparated: string = "";
    //FileLinksPipeSeparated: string = "";
    ModifiedDate: string;
    VersionLabel: string = "";
    DependenciesPipeSeparated: string = "";
    FileNames: string[] = [];
    FileLinks: string[] = [];

    DisplayName: string;
    DisplayComments: string;
    DisplayCompletionCriteria: string;
    DisplayMilestoneTask: string;
    DisplayCriticalTask: string;
    DisplayMostCurrentTask: string;
    DisplayStaff: string;
    DisplayFiles: string;
    StaffList: string[];
    FileList: string[];
    DependencyList: string[] = [];
    GanttTaskCategory: string;

    Initialize(): void {

        //console.log(this);

        //if (this.ActualEndDate) { this.Status = "Completed"; }
        //else if (this.ActualStartDate) { this.Status = "In Progress"; }
        //else { this.Status = "Not Started"; }

        //0: Not Started, 1: In Progress, 2: Complete, 3: Past Due, 4: Unknown
        let plannedStart: Date = this.getDate(this.PlannedStartDate);
        let plannedEnd: Date = this.getDate(this.PlannedEndDate);
        let actualStart: Date = this.getDate(this.ActualStartDate);
        let actualEnd: Date = this.getDate(this.ActualEndDate);

        let plannedEndBeforeToday: boolean = false;
        if (plannedEnd != undefined) plannedEndBeforeToday = plannedEnd < new Date();

        this.StatusId = 4; //unknown
        if (actualEnd != undefined) this.StatusId = 2; //complete
        else if (actualStart != undefined && !plannedEndBeforeToday) this.StatusId = 1; //in progress
        else if (plannedEndBeforeToday) this.StatusId = 3; //overdue
        else if (plannedStart != undefined && actualStart == undefined) this.StatusId = 0; //not started

        switch (this.StatusId) {
            case 0: this.Status = "Not Started"; break;
            case 1: this.Status = "In Progress"; break;
            case 2: this.Status = "Complete"; break;
            case 3: this.Status = "Overdue"; break;
            case 4:
            default: this.Status = "Unknown"; break;
        }

        //if (this.Name == "Q4 CSR Template") {
        //    console.log(plannedStart), plannedEnd, actualStart, actualEnd, this);
        //}

        if (this.PlannedStartDate) this.PlannedStartDate += ' 00:00:00';
        if (this.PlannedEndDate) this.PlannedEndDate += ' 00:00:00';
        if (this.ActualEndDate) this.ActualEndDate += ' 00:00:00';;

        if (this.ActualStartDate == undefined) this.ActualStartDate = "";
        else if (this.ActualStartDate.length > 0) this.ActualStartDate += ' 00:00:00';
        else if (this.ActualEndDate) { this.ActualStartDate = this.ActualEndDate; } //if no actual start but an actual end, use same date

        this.DisplayName = FormatStringByWordLength(this.Name, 5);
        this.DisplayComments = FormatStringByWordLength(this.Comments, 6);
        this.DisplayCompletionCriteria = FormatStringByWordLength(this.CompletionCriteria, 6);

        if (this.IsMilestoneTask) this.DisplayMilestoneTask = "Yes";
        else this.DisplayMilestoneTask = "No";

        if (this.IsCriticalTask) this.DisplayCriticalTask = "Yes";
        else this.DisplayCriticalTask = "No";

        if (this.IsMostCurrentTask) this.DisplayMostCurrentTask = "Yes";
        else this.DisplayMostCurrentTask = "No";

        if (this.StaffPipeSeparated) {
            this.StaffList = Split(this.StaffPipeSeparated, "|");
            this.DisplayStaff = Join(this.StaffList, ", ", false, true);
        }
        else this.DisplayStaff = "";

        if (this.FileLinks) {
            this.FileList = this.FileLinks.map((file: string, index: number) => {
                let filename: string = "File";
                if (this.FileNames[index]) { filename = this.FileNames[index]; }
                return "<a href='" + file + "' target='_blank'><span class='nowrap'>" + filename +"<i class='fa fa-external-link-alt link-icon' aria-hidden='true'></i></span></a>";
            });
            //console.log(this.FileLinksPipeSeparated, this.FileList);
            this.DisplayFiles = Join(this.FileList, "<br>", false, true);
        }
        else this.DisplayFiles = "";

        if (this.DependenciesPipeSeparated) {
            //this.DependencyList = Split(this.DependenciesPipeSeparated, "|");
            //console.log(this);
        }
        else this.DependencyList = [];
    }

    private getDate(dateString: string): Date {
        if (dateString == undefined || dateString.length == 0) return undefined;
        else return GetDateFromString(dateString, "hyphens-year-month-day");
    }

    matchesFilter(category: any, status: any, milestoneTask: any, criticalTask: any, mostCurrentTask: any): boolean {

        if (!DoArraysOverlap(category, this.TaskCategory)) { return false; }
        if (!DoArraysOverlap(status, this.Status)) { return false; }

        if (milestoneTask != undefined) {
            if (!DoArraysOverlap(milestoneTask, this.DisplayMilestoneTask)) { return false; }
        }
        if (criticalTask != undefined) {
            if (!DoArraysOverlap(criticalTask, this.DisplayCriticalTask)) { return false; }
        }
        if (mostCurrentTask != undefined) {
            if (!DoArraysOverlap(mostCurrentTask, this.DisplayMostCurrentTask)) { return false; }
        }

        return true;
    }
}